import { CountUp } from "countup.js"

document.addEventListener('DOMContentLoaded', () => {

    const countup = document.querySelectorAll('.countup');
    if( !countup ) return false;


    countup.forEach( ( item, index ) => {
        item.style.width = `${item.offsetWidth}px`;

        const suffix = item.innerHTML.replace(/\d+/g, "");

        const counter = new CountUp(item, parseInt(item.innerHTML), {
            useEasing: true,
            useGrouping: true,
            separator: "",
            decimal: "",
            suffix: suffix,
            enableScrollSpy: true 
        });
        
        counter.start();
    } )

});